module.exports = __webpack_public_path__ + "static/media/graphicImage.e1946f42.png";